import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import stakContract from "../../../../Contract/stakContract.json";
import zeussToken from "../../../../Contract/zeussToken.json";
import icoContract from "../../../../Contract/ISOContract.json";
import { useAccount } from "wagmi";
import stakeContract from "../../../../Contract/stakContract.json";
import ICOContract from "../../../../Contract/ISOContract.json";
import Reward from "../Modal/Reward";
import {
  getUserBalances,
  callReadContract,
  formatBalance,
  formatNumber,
  callWriteContract,
  getTxn,
  parsBalance,
} from "../../../../Contract/utils";
import { toast } from "react-toastify";

function MyVerticallyCenteredModal(props) {
  const user = useAccount();
  const [amount, setAmount] = useState("");
  const [duration, setDuration] = useState(15724800);


  useEffect(() =>{
    if(props.tokenToStake){
      setAmount(props.tokenToStake)
    }
  }, [props])

  const getLockedDate = (duration) => {
    const lockedDate = new Date(Date.now() + duration * 1000);
    return lockedDate.toLocaleDateString("en-GB"); // Format: DD-MM-YYYY
  };

  const stakeToken = async () => {
    try {
      if (amount === "") {
        toast.error("No amount added!");
        return;
      }

      if (amount > props.bal) {
        toast.error("Token balance is less than the required amount!");
        return;
      }
      let load = toast.loading("Staking...");

      const buyAmount = parsBalance(amount, 18);

      const approve = await callWriteContract(
        zeussToken.address,
        zeussToken.abi,
        "approve",
        [stakContract.address, buyAmount]
      );

      const appreceipt = await getTxn(approve);
      if (!appreceipt) {
        toast.error("Approving Failed!");
        toast.dismiss(load);
        return;
      }

      const tx = await callWriteContract(
        stakContract.address,
        stakContract.abi,
        "stake",
        [buyAmount, duration]
      );

      const receipt = await getTxn(tx);
      if (!receipt) {
        toast.error("Staking Failed!");
        toast.dismiss(load);
        return;
      }

      toast.success("Staking Successfull!");
      toast.dismiss(load);
      props.setTrans(tx);
      props.onStake(tx);
      props.setTxn(tx);
      props.onHide();
      setAmount("");
    } catch (e) {
      console.log("error stakeToken", e);
    }
  };

  return (
    <Modal
      className="wallet-modal reward"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <img src="/images/close.png" onClick={props.onHide} alt="" />
      </Modal.Header>
      <Modal.Body className="px-5">
        <div className="wallet-main">
          <div className="form-group">
            <div className="form-heading mb-2">
              <label>Amount</label>
            </div>
            <div className="form">
              <div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="0.00 ~$0"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </div>
              <div className="select">
                <img src="/images/zeusscircle.png" alt="" />
              </div>
            </div>
            <div className="form-heading mt-2">
              <div>
                <label>
                  Wallet Balance : {props.bal}
                  <b> ZEUSS</b>
                </label>
              </div>
              <div>
                <label
                  className="half"
                  onClick={() => setAmount(props.bal / 2)}
                >
                  HALF
                </label>
                <label className="half" onClick={() => setAmount(props.bal)}>
                  MAX
                </label>
              </div>
            </div>
            <div className="form-heading mb-2">
              <label>Duration</label>
            </div>
            <div className="btns">
              <button
                type="button"
                className={`btn ${
                  duration === 15724800 ? "" : "six"
                } form-control`}
                onClick={() => setDuration(15724800)}
              >
                6 Months
              </button>

              <button
                type="button"
                className={`btn ${
                  duration === 31536000 ? "" : "six"
                } form-control`}
                onClick={() => setDuration(31536000)}
              >
                12 Months
              </button>
            </div>
            <div className="detail">
              <div>
                <h4>Amount</h4>
                <h5>USD: {(amount * props.tokenValue).toFixed(2)}</h5>
              </div>
              {/* <div>
                <h4>APR</h4>
                <h5>{amount /}%</h5>
              </div> */}
              <div>
                <h4>Locked Until</h4>
                <h5>{getLockedDate(duration)}</h5>
              </div>
            </div>
            <hr className="my-4" />

            {/* <img src="/images/separater.png" className="my-4" alt="" /> */}
            <div className="btns pb-5">
              <button
                type="button"
                class="btn back form-control"
                onClick={props.onHide}
              >
                Back
              </button>
              <button
                type="button"
                class="btn form-control"
                onClick={stakeToken}
              >
                Lock
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default function Stake({
  onStake,
  bal,
  tokenValue,
  setTxn,
  show,
  setOpenStake,
  btn,
  tokenToStake
}) {
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    setModalShow(show);
  }, [show]);  

  return (
    <>
      {btn && (
        <button
          onClick={() => {
            setModalShow(true);
            if (setOpenStake) {
              setOpenStake(false);
            }
          }}
          type="button"
          className="start"
        >
          <img src="/images/reward.png" alt="" />
          Stake Now
        </button>
      )}

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => {
          setModalShow(false)
          if(setOpenStake){

            setOpenStake(false)
          }
        }}
        setTrans={onStake}
        bal={bal}
        tokenValue={tokenValue}
        setTxn={setTxn}
        onStake={onStake}
        tokenToStake={tokenToStake}
      />
    </>
  );
}
